<div class="resolve-wrapper" [class.__over-modal]="overModal">
  <div class="resolve animated zoomIn" role="dialog" aria-modal="true" aria-labelledby="resolve-title">
    <div class="resolve-header">
      <h3 id="resolve-title">{{ copy.REVIEW_CHANGES }}<span *ngIf="partNumber" class="resolve-part"> — {{ partNumber }}</span></h3>
      <div (click)="cancelled.emit()" class="close" role="button" aria-label="Close"></div>
    </div>

    <p class="resolve-intro">{{ copy.RESOLVE_INTRO }}</p>

    <p class="resolve-state" *ngIf="!rows && !error">{{ copy.RESOLVE_LOADING }}</p>

    <p class="resolve-error" *ngIf="error">
      <span>{{ error }}</span>
      <a role="button" (click)="retry.emit()">Try again</a>
    </p>

    <p class="resolve-state" *ngIf="ready && !rows!.length">{{ copy.RESOLVE_NOTHING }}</p>

    <div class="resolve-table-wrap" *ngIf="ready && rows!.length">
      <table class="resolve-table">
        <thead>
          <tr>
            <th scope="col">Field</th>
            <th scope="col">Yours</th>
            <th scope="col">Current</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of rows; trackBy: trackByKey">
            <th scope="row">
              <span>{{ row.label }}</span>
              <span class="resolve-tag" *ngIf="row.edited">Edited</span>
            </th>
            <td>
              <label class="resolve-choice" [class.__disabled]="!row.writable" [attr.title]="row.writable ? null : copy.RESOLVE_NOT_WRITABLE">
                <input type="radio" [name]="'resolve-' + row.key" [checked]="isChosen(row, 'yours')" [disabled]="!row.writable"
                  (change)="choose(row, 'yours')">
                <span class="resolve-value">{{ row.yours }}</span>
              </label>
              <small class="resolve-locked" *ngIf="!row.writable">{{ copy.RESOLVE_NOT_WRITABLE }}</small>
            </td>
            <td>
              <label class="resolve-choice">
                <input type="radio" [name]="'resolve-' + row.key" [checked]="isChosen(row, 'current')"
                  (change)="choose(row, 'current')">
                <span class="resolve-value">{{ row.current }}</span>
              </label>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="resolve-ctrl">
      <div class="resolve-ctrl__group">
        <a role="button" class="btn __secondary" [class.__disabled]="!ready" (click)="discardChanges()">{{ copy.DISCARD_MY_CHANGES }}</a>
      </div>
      <div class="resolve-ctrl__group">
        <a role="button" class="btn __secondary" (click)="cancelled.emit()">Cancel</a>
        <a role="button" class="btn" [class.__disabled]="!ready" (click)="apply()">Apply</a>
      </div>
    </div>
  </div>
</div>
